module.exports = __webpack_public_path__ + "static/media/L2.aef1f48d.jpg";